

























































/** Тип задания выражен адресом создания и в теле запроса не передаётся */
import { Component, Prop, Vue } from 'vue-property-decorator';

import { MmTaskType } from '../../../types/enums';
import {
	getTaskTypeProfile,
	listTaskTypeOptions,
	MmTaskTypeListOption,
	MmTaskTypeProfile,
} from '../taskTypeProfile';

const KEY = 'priceMonitoring.mobileMonitoring.';

interface MmTaskTypeOption {
	type: MmTaskType;
	label: string;
	isDisabled: boolean;
	disabledReason: string;
}

/** Тип события описан здесь: ant-design-vue 1.7.8 своего наружу не отдаёт */
interface MmCheckboxChangeEvent {
	target: { checked: boolean };
}

@Component
export default class TaskTypeBlock extends Vue {
	@Prop({ default: null }) readonly value!: MmTaskType | null;

	@Prop({ default: false }) readonly priceChecker!: boolean;

	@Prop({ default: false }) readonly disabled!: boolean;

	@Prop({ default: false }) readonly fixed!: boolean;

	fieldLabelId(field: string): string {
		return 'sm-mobilemon-task-type-' + field + '-label-' + String((this as any)._uid);
	}

	get stepTitle(): string {
		return this.$t(KEY + 'taskForm.stepType') as string;
	}

	get placeholderText(): string {
		return this.$t(KEY + 'taskForm.typePlaceholder') as string;
	}

	get selectedLabel(): string {
		const profile = this.profile;

		return profile !== null ? (this.$t(profile.labelKey) as string) : '';
	}

	get priceCheckerLabel(): string {
		return this.$t(KEY + 'taskForm.priceChecker') as string;
	}

	get profile(): MmTaskTypeProfile | null {
		return getTaskTypeProfile(this.value);
	}

	get hasPriceChecker(): boolean {
		const profile = this.profile;

		return profile !== null && profile.hasPriceChecker === true;
	}

	get typeExplanationText(): string {
		const profile = this.profile;

		if (profile === null) {
			return '';
		}

		return this.$t(profile.typeExplanationKey) as string;
	}

	/** Для a-select нужен undefined: null доезжает как [null] и подменяет подсказку пустой опцией */
	get selectValue(): MmTaskType | undefined {
		return this.value !== null ? this.value : undefined;
	}

	get typeOptions(): MmTaskTypeOption[] {
		const self = this;

		return listTaskTypeOptions().map(function (option: MmTaskTypeListOption): MmTaskTypeOption {
			return {
				type: option.type,
				label: option.labelKey !== '' ? (self.$t(option.labelKey) as string) : String(option.type),
				isDisabled: option.isDisabled,
				disabledReason: option.disabledReasonKey !== null
					? (self.$t(option.disabledReasonKey) as string)
					: '',
			};
		});
	}

	private isTypeAvailable(type: MmTaskType): boolean {
		const options = this.typeOptions;

		for (let i = 0; i < options.length; i += 1) {
			if (options[i].type === type) {
				return !options[i].isDisabled;
			}
		}

		return false;
	}

	handleTypeChange(type: MmTaskType): void {
		if (this.disabled) {
			return;
		}

		if (type === this.value) {
			return;
		}

		if (!this.isTypeAvailable(type)) {
			return;
		}

		this.$emit('change', type);
	}

	handlePriceCheckerChange(event: MmCheckboxChangeEvent): void {
		if (this.disabled) {
			return;
		}

		const checked = event && event.target ? event.target.checked : false;

		this.$emit('change-price-checker', checked === true);
	}
}
